module.exports = __webpack_public_path__ + "img/mydha1 (2).ac89239b.png";